import apiClient from '@/services/api-client';

export const getAllUser = async (params = {}) => {
  const response = await apiClient.get('/user/list', { params });
  return response.data;
};

export const createUser = async (user , params = {}) => {
  const response = await apiClient.post('/user/create', user, { params });
  return response.data;
};

export const changeUserPassword = async (changePw) => {
  const response = await apiClient.post('/user/change-user-password', changePw);
  return response.data;
};

export const changeUserStatus = async (userId, params = {} ) => {
  const response = await apiClient.get('/user/change-status/'+ userId  , {params});
  return response.data;
};
